// extracted by mini-css-extract-plugin
export default {"m":"_1f2cded649","title":"_028d1d0191","feedback_inner_title":"_30c981517a","textarea":"f6b46ab240","radio":"_3afad45d82","text":"_1d05ffaceb"};